// extracted by mini-css-extract-plugin
export default {"enter":"PropertyList_enter__K6RnO","enterActive":"PropertyList_enterActive__bfGCY","exit":"PropertyList_exit__jDmBA","exitActive":"PropertyList_exitActive__YnPZw"};